import ApiClient from '@/ApiClient';
import { queryOptions } from '@tanstack/vue-query';

// `filters` is a ref/computed of { starts_on, ends_on }; refetches on change. getFailedSalaries can
// dupe a salary_id across FAILED rows — keep the earliest failed_at (longest time-in-failed), oldest first.
export const getFailedSalaryReport = filters =>
  queryOptions({
    queryKey: ['failed_salary_report', filters],
    queryFn: async () => {
      const response = await ApiClient.getFailedSalaries(filters.value);
      const rows = response?.data ?? [];

      const earliestBySalaryId = new Map();
      rows.forEach(row => {
        // Backend inner-joins on salary_id, so it's always present; skip defensively rather than key on the object.
        if (row.salary_id == null) {
          return;
        }
        const existing = earliestBySalaryId.get(row.salary_id);
        if (!existing || new Date(row.failed_at) < new Date(existing.failed_at)) {
          earliestBySalaryId.set(row.salary_id, row);
        }
      });

      return [...earliestBySalaryId.values()].sort((a, b) => new Date(a.failed_at) - new Date(b.failed_at));
    },
  });
